import {EndpointUri} from '@src/@types/EndpointUri';
import app from '@src/helpers/app';

export default function getDashboardEndpoint(
    page: 'manager-order-page' | 'manager-order-product-page' | 'production-order-product-page',
    entityId: number | string | null | undefined,
): EndpointUri {
    return {
        route: app('names-resolver').clientRoutes.getRouteName('Dashboards', page),
        params: {id: String(entityId)},
    };
}
